//vendors
import React, {useMemo} from 'react';
import Select from 'react-select';
import classNames from "classnames";

//styles
import styles from './dropdown.module.scss';
import {VBox} from "@acc/layout";
import {Tooltip} from "@acc/tooltip";

export type tOption = {
	value: string,
	label: string
}

export type Props = {
	options: Array<tOption | any>,
	value?: tOption | null,
	onChange: (value: any) => void,
	placeholder?: string,
	className?: string,
	classNameWrap?: string,
	isSearchable?: boolean,
	menuPortalTarget?: HTMLElement,
	error?: string | boolean,
	styles?: any,
	withBorder?: boolean,
	isDisabled?: boolean,
	isMulti?: boolean,
	label?: string,
	onBlur?: () => void,
	required?: boolean,
	tooltip?: string | JSX.Element
};

export const Dropdown = (props: Props) => {
	const selectComponent = (
		<Select
			options={props.options}
			className={
				classNames(
					"custom-select-container",
					props.className,
					{"error": props.error},
					{"withBorder": props.withBorder}
				)
			}
			classNamePrefix="custom-select"
			value={props.value && props.value}
			onChange={props.onChange}
			placeholder={props.placeholder}
			isSearchable={props.isSearchable}
			menuPortalTarget={props.menuPortalTarget}
			styles={{menuPortal: base => ({...base, zIndex: 9999}), ...props.styles}}
			isDisabled={props.isDisabled}
			onBlur={props.onBlur}
			isMulti={props.isMulti}
		/>
	);

	const InnerLabel =useMemo(() => (
		<span>{props.required && <span className={styles.requiredStatus}>* </span>}{props.label}</span>
	), [props.required, props.label])

	if (props.label) {
		return (
			<div className={classNames(styles.dropdownWrap, props.classNameWrap)}>
				<label>
					{props.tooltip
						? (
							<Tooltip
								message={<VBox className={styles.tooltipMsg}>{props.tooltip}</VBox>}
								placement="top"
								trigger="hover"
								delayShow={1000}
							>
								{InnerLabel}
							</Tooltip>
						)
						: InnerLabel
					}
				</label>

				{selectComponent}
			</div>
		);
	}
	
	return selectComponent;
}

Dropdown.defaultProps = {
	isSearchable: false,
	withBorder: false,
	isDisabled: false,
	isMulti: false,
	required: true
};
